import { PROJECT_GOVERNANCE } from '../../../governanceBridge.js'

// Every feature declares its Supabase project so `getClient()` from
// sdk-bridge routes to the right federation member.
export const CHAT_CONFIG = {
  projectName: PROJECT_GOVERNANCE,
  tables: {
    channels: 'chat_channels',
    channelMembers: 'chat_channel_members',
    messages: 'chat_messages',
    reactions: 'chat_reactions',
    mentions: 'chat_mentions'
  }
}
